import type { SetupWorker } from 'msw/lib/browser';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initializeTracking } from 'utils/tracking';

import { App } from 'containers/App';

initializeTracking();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

async function enableMocking(worker: SetupWorker) {
  const { isRunningInsideCypress } = await import('utils/test-utils');
  if (!isRunningInsideCypress()) {
    return Promise.resolve();
  }

  // `worker.start()` returns a Promise that resolves
  // once workerTest Service Worker is up and ready to intercept requests.
  return worker.start({
    waitUntilReady: true,
    onUnhandledRequest: 'bypass'
  });
}

// Load mswWorker only outside production deployments
const preloader =
  process.env.DEPLOYMENT_ENV === 'production'
    ? Promise.resolve(undefined)
    : import('../msw/mswWorker').then(({ worker }) => enableMocking(worker));

preloader.then(() => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
